import FJHoverBoardGradation from '../FJHoverBoard/FJHoverBoardGradation';
import colorBtuBase64 from '../../../assets/base64/color-btu.js';

import styles from './FJColorPanel.module.less';
import FJButton from '../FJButton/FJButton.jsx';
import FJDropDown from '../FJDropDown/FJDropDown.jsx';
import FJColorPickerPanel from '../FJColorPickerPanel/FJColorPickerPanel.jsx';
import FJConstant from '../../../constants/FJConstant.js';

const FJColorPanel = props => {
    const { colorList, activeColor, onChange, onHide, removeClick, btuText = 'remove' } = props;

    return (
        <div className={styles.panel}>
            <FJDropDown
                hideEvent={'colorDropDown'}
                isTopLayer={true}
                placement={'leftCenter'}
                propsLeft={-10}
                propsTop={110}
                onHide={onHide}
                overlay={<FJColorPickerPanel activeColor={activeColor} onChange={onChange} />}
            >
                <FJHoverBoardGradation key={'btu'} isShowInBorder={true} borderRadius={6}>
                    <div className={styles.color_item} style={{ backgroundImage: `url(${colorBtuBase64})` }}></div>
                </FJHoverBoardGradation>
            </FJDropDown>

            {colorList.map(color => {
                const active = color === activeColor;
                return (
                    <FJHoverBoardGradation
                        key={color}
                        active={active}
                        isShowInBorder={true}
                        borderRadius={6}
                        hasHover={!active}
                        onClick={e => onChange(color, FJConstant.CLICK)}
                    >
                        <div className={styles.color_item} style={{ backgroundColor: color }}></div>
                    </FJHoverBoardGradation>
                );
            })}

            <div className={styles.btn_box}>
                <FJButton text={btuText} onClick={removeClick} className={styles.btn} />
            </div>
        </div>
    );
};

export default FJColorPanel;
